import React, { useRef } from "react"
import {
    CardTitle,
} from "reactstrap"
import DropzoneComponent from "react-dropzone-component"

// Breadcrumb
const FormUpload = (props) => {
    const dzRef = useRef(null);
    const config = {
        iconFiletypes: [".jpg", ".png", ".jpeg", ".pdf"],
        showFiletypeIcon: false,
        postUrl: `${process.env.REACT_APP_SERVER_URL}/api2/upload/files/${props.objId}/${props.type}`
    }

    const dropzone = null

    const djsConfig = {
        addRemoveLinks: false,
        dictDefaultMessage: 'ატვირთეთ ფაილები: PDF, Excel, Word, TXT ან PNG',
        dictMaxFilesExceeded: "You can upload 6 photos only at a time",
        dictResponseError: "The file is too large to upload!",
        // acceptedFiles: "application/pdf",
        acceptedFiles: '.pdf,.xlsx,.xls,.doc,.docx,.txt,.png,.jpg',
        maxFiles: "12",
    }

    const removedfile = () => {
    }

    const success = () => {
        // console.log("!!!success")
    }

    const callback = (e) => {
        //console.log("callback", e)
    }
    const callbackArray = [
        function () {
            console.log('Look Ma, I\'m a callback in an array!');
        },
        function () {
            console.log('Wooooow!');
        }
    ];
    const eventHandlers = {
        init: (dz) => {
            dzRef.current = dz;

            // отдаём наружу метод очистки
            if (props.onReady) {
                props.onReady({
                    clear: () => dz.removeAllFiles(true),
                });
            }
        },
        drop: callbackArray,
        addedfile: callback,
        success: success,
        removedfile: removedfile
    }

    return (
        <React.Fragment>
            <CardTitle className="h4">{props.message}</CardTitle>
            <DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig} />
        </React.Fragment>
    )
}

export default FormUpload
